import { observer } from 'mobx-react-lite'
import { DropdownItem, EnumDropdownItemVariant, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { DayjsFormats } from 'shared/lib'
import { type HubspotControl } from 'widgets/FilterEditor/ui/Widget/WidgetHubspot/store/HubspotControl'
import { type IFilterValue } from 'widgets/FilterEditor/types/types'
import styles from './styles.module.scss'

type IHubspotItemProps = {
  item: IFilterValue
  control: HubspotControl
  onChange: (key: number | string) => void
}

export const WidgetHubspotMultiDropdownItem = observer(
  ({ control, item, onChange }: IHubspotItemProps) => (
    <DropdownItem
      item={{
        id: item.key,
        label: item.name || '',
        labelContent: (
          <Typography
            variant={'body-md-regular'}
            className={styles.dropdownItem}
            ariaLabel={'priceLabel'}
          >
            {item.name || ''} <span className={styles.optionCounter}>({item.count || 0})</span>
          </Typography>
        ),
        tooltipProps: {
          visibility: 'hidden',
        },
        parentTooltipProps: {
          fullWidth: true,
          placement: 'left',
          label: [
            <>
              <Typography
                tag={'div'}
                key={'hubSpot_list_tooltip'}
                ariaLabel={'HubSpotListTooltip'}
                variant={'body-md-regular'}
                color={'var(--content-primary-primary-inverted)'}
                marginBottom={2}
              >
                {item.name || ''}
              </Typography>
              <Typography
                tag={'div'}
                key={'time'}
                variant={'body-sm-regular'}
                color={'var(--content-primary-tertiary-inverted)'}
                ariaLabel={'SyncedAt'}
              >
                Last sync -&nbsp;
                {(item?.synced_at &&
                  uiStore.dayjs(item?.synced_at).format(DayjsFormats.fullWithAtDash2)) ||
                  'Never synced'}
              </Typography>
            </>,
          ],
        },
        labelBrackets: String(item.count || 0),
        variant: EnumDropdownItemVariant.Checkbox,
        isCardClick: true,
        activeValue: control.isSelected(item.key),
      }}
      onChange={() => onChange(item.key)}
    />
  )
)
